// extracted by mini-css-extract-plugin
export default {"modal__wrapper":"SideModal_modal__wrapper__OqItK","modal":"SideModal_modal__0QhJG"};